import React, { useState, useContext, useEffect } from 'react';
import Slider from '@material-ui/core/Slider';
import useStyles from "./styles";
import SurveyQuestionContext from '../../../../context/surveyquestion-context';

const ProgressBarQuestion = ({ marks, index }) => {
    const classes = useStyles();
    const [value, setValue] = useState(-1)
    const { surveyQuestionContext, dispatch } = useContext(SurveyQuestionContext);

    useEffect(() => {
        if (surveyQuestionContext.scaleAnswers.length !== 0) {
            const answer = surveyQuestionContext.scaleAnswers.find(element => element && marks[0].questionId === element.questionId);
            if (answer) {
                const indexAnswer = marks.findIndex(element => element.id === answer.id)
                if (indexAnswer !== -1) {
                    setValue((100 / (marks.length - 1)) * indexAnswer)
                }
            } else {
                setValue(-1)
            }

        } else {
            setValue(-1)
        }
    }, [index])

    marks && marks.forEach((element, position) => {
        element.value = (100 / (marks.length - 1)) * position
        element.label = element.scaleQuestionOptionContent
    });

    const handleChange = (val) => {
        const position = (val * (marks.length - 1)) / 100
        setValue(val)
        surveyQuestionContext.scaleAnswers[index] = marks[position];
        dispatch({ type: 'SET_SCALE_ANSWERS', scaleAnswers: surveyQuestionContext.scaleAnswers });
    }

    return (
        <div className={classes.root}>
            <Slider
                value={value}
                aria-labelledby="discrete-slider-always"
                step={100 / (marks.length - 1)}
                marks={marks}
                track={false}
                classes={{
                    root: classes.rootMuiSlider,
                    rail: classes.railMuiSlider,
                    mark: classes.markMuiSlider,
                    thumb: value >= 0 ? classes.thumbMuiSlider : classes.thumbMuiSliderDefault,
                    markLabel: classes.markLabelMuiSlider,
                    markLabelActive: value >= 0 ? classes.markLabelActiveMuiSlider : classes.markLabelActiveMuiSliderDefault,
                }}
                className='surveyquestion__slider'
                onChange={(event, value) => handleChange(value)}
            />
        </div>
    );
}

export default ProgressBarQuestion;